import {TypeImpl} from './TypeImpl';
import {Type} from './Type';
import {Helper} from "../../Helper";

export interface Option {
    code: string;
    description: string;
    selected: boolean;
};

export class TypeSelect extends TypeImpl implements Type {

    private select: HTMLElement;
    private aInput: HTMLInputElement;
    private currentFocus: number;
    private activeOption: Option;

    public execute(): void {
        let options = this.optionsToArray();
        let containetSelect = this.target.parentNode as HTMLElement;
        Helper.insertAfter(this.createAutocompleteElement(), containetSelect);
        this.eventInput(this.aInput, options, false);
        this.eventInputFocus(this.aInput, options);
        this.eventKeydown(this.aInput);
        this.eventDocClick();
    }

    private createAutocompleteElement(): HTMLElement {
        this.select = this.target.parentNode as HTMLElement;
        this.select.className = "bbselect";
        this.aInput = document.createElement('input');
        this.aInput.type = 'text';
        this.aInput.readOnly = true;
        this.aInput.placeholder = this.getPlaceholder();
        if (this.activeOption.code.length > 0) {
            this.aInput.value = this.activeOption.description;
            this.triggerEvent(this.aInput, 'change');
        }
        this.aInput.id = this.target.id;
        this.select.appendChild(this.aInput);
        return this.select;
    }

    private eventDocClick() {
        let globalThis = this;
        document.addEventListener("click", function (e) {
            globalThis.closeAllLists(e.target);
        });
    }

    private eventInputFocus(inp: HTMLInputElement, options: Option[]) {
        let globalThis = this;
        /*execute a function presses a key on the keyboard:*/
        inp.addEventListener("focus", function (e) {
            globalThis.initAutoCompite(inp, options, true);
        });
    }

    private eventKeydown(inp: HTMLInputElement) {
        let globalThis = this;
        /*execute a function presses a key on the keyboard:*/
        inp.addEventListener("keydown", function (e) {
            let selectList = document.getElementById(this.id + "select-list");
            let x: HTMLDivElement[];
            if (selectList) {
                // @ts-ignore: Unreachable code error
                x = selectList.getElementsByTagName("div");
            }
            if (e.keyCode == 40) {
                /*If the arrow DOWN key is pressed,
                 increase the currentFocus variable:*/
                globalThis.currentFocus++;
                /*and and make the current item more visible:*/
                globalThis.addActive(x);
            } else if (e.keyCode == 38) { //up
                /*If the arrow UP key is pressed,
                 decrease the currentFocus variable:*/
                globalThis.currentFocus--;
                /*and and make the current item more visible:*/
                globalThis.addActive(x);
            } else if (e.keyCode == 13) {
                /*If the ENTER key is pressed, prevent the form from being submitted,*/
                e.preventDefault();
                if (globalThis.currentFocus > -1) {
                    /*and simulate a click on the "active" item:*/
                    if (x)
                        x[globalThis.currentFocus].click();
                }
            }
        });
    }

    private eventInput(inp: HTMLInputElement, arr: Option[], isAll: boolean) {
        let globalThis = this;
        /*execute a function when someone writes in the text field:*/
        inp.addEventListener("input", function (e) {
            globalThis.initAutoCompite(inp, arr, isAll);
        });
    }

    private initAutoCompite(inp: HTMLInputElement, arr: Option[], isAll: boolean) {
        var a, b, i, val = inp.value;
        if (isAll) {
            val = "";
        }
        /*close any already open lists of selectd values*/
        this.closeAllLists();
        //            if (!val) {
        //                return false;
        //            }
        this.currentFocus = -1;
        /*create a DIV element that will contain the items (values):*/
        a = document.createElement("div");
        a.setAttribute("id", inp.id + "select-list");
        a.setAttribute("class", "select-items");
        /*append the DIV element as a child of the select container:*/
        inp.parentNode.appendChild(a);
        /*for each item in the array...*/
        for (i = 0; i < arr.length; i++) {
            /*check if the item starts with the same letters as the text field value:*/
            let searchPosition = arr[i].description.toUpperCase().indexOf(val.toUpperCase());
            if ((isAll || searchPosition != -1) && arr[i].code.length) {
                /*create a DIV element for each matching element:*/
                b = document.createElement("div");
                /*make the matching letters bold:*/
                let html = "";
                html += arr[i].description.substr(0, searchPosition);
                html += "<span>" + arr[i].description.substr(searchPosition, val.length) + "</span>";
                html += arr[i].description.substr(searchPosition + val.length);
                /*insert a input field that will hold the current array item's value:*/
                html += '<input type="hidden" value="' + this.htmlEntities(arr[i].description) + '"/>';
                html += '<input type="hidden" value="' + i + '"/>';
                b.innerHTML = html;
                let globalThis = this;
                /*execute a function when someone clicks on the item value (DIV element):*/
                b.addEventListener("click", function (e) {
                    /*insert the value for the select text field:*/
                    let posEl = this.getElementsByTagName("input")[1].value;
                    globalThis.activeOption = (arr as any)[posEl];
                    inp.value = this.getElementsByTagName("input")[0].value;
                    globalThis.triggerEvent(inp, 'change');
                    globalThis.target.value = globalThis.activeOption.code;
                    globalThis.triggerEvent(globalThis.target, 'change');
                    /*close the list of selectd values,
                     (or any other open lists of selectd values:*/
                    globalThis.closeAllLists();
                });
                a.appendChild(b);
            }
        }
    }

    private htmlEntities(input: string) {
        input = input.replace(/&/g, '&amp;');
        input = input.replace(/</g, '&lt;');
        input = input.replace(/"/g, '&quot;');
        input = input.replace(/>/g, '&gt;');
        return input;
    }

    private addActive(x: HTMLElement[]) {
        /*a function to classify an item as "active":*/
        if (!x)
            return false;
        /*start by removing the "active" class on all items:*/
        this.removeActive(x);
        if (this.currentFocus >= x.length)
            this.currentFocus = 0;
        if (this.currentFocus < 0)
            this.currentFocus = (x.length - 1);
        /*add class "select-active":*/
        x[this.currentFocus].classList.add("select-active");
    }

    private removeActive(x: HTMLElement[]) {
        /*a function to remove the "active" class from all select items:*/
        for (var i = 0; i < x.length; i++) {
            x[i].classList.remove("select-active");
        }
    }

// @ts-ignore: Unreachable code error
    private closeAllLists(elmnt = null) {
        /*close all select lists in the document,
         except the one passed as an argument:*/
        if (this.aInput.value.length == 0 && this.target.value.length > 0) {
            this.target.value = '';
            this.triggerEvent(this.target, 'change');
        }
        var x = document.getElementsByClassName("select-items");
        for (var i = 0; i < x.length; i++) {
            let input = x[i].parentNode.querySelector('input[type=text]');
            if (elmnt != input && elmnt != this.aInput) {
                x[i].parentNode.removeChild(x[i]);
            }
        }
    }

    private optionsToArray(): Option[] {
        // @ts-ignore: Unreachable code error
        let optionElementList = (this.target as HTMLSelectElement).options;
        let options = [];
        for (let i = 0; i < optionElementList.length; i++) {
            let option = {
                code: optionElementList[i].value,
                description: optionElementList[i].innerHTML,
                selected: optionElementList[i].selected
            };
            if (optionElementList[i].selected) {
                this.activeOption = option;
            }
            options[options.length] = option;
        }
        return options;
    }

    private getPlaceholder(): string {
        // @ts-ignore: Unreachable code error
        let optionElementList = (this.target as HTMLSelectElement).options;
        for (let i = 0; i < optionElementList.length; i++) {
            if (optionElementList[i].value.length == 0) {
                return optionElementList[i].innerHTML;
            }
        }
        return '';
    }

}
